import React, {
	useContext,
	useEffect,
	useState
} from 'react';
import List
	from "@material-ui/core/List";
import ListItem
	from "@material-ui/core/ListItem";
import Collapse
	from '@material-ui/core/Collapse';
import ListItemText
	from '@material-ui/core/ListItemText';
import ExpandLess
	from '@material-ui/icons/ExpandLess';
import ExpandMore
	from '@material-ui/icons/ExpandMore';
import { useTranslation } from "react-i18next";
import { DataContext } from "../../store/DataProvider";

const MenuView = props => {
	const { t } = useTranslation();
	const context = useContext(DataContext)
	const [categories, setCategories] = useState({})
	const [rule_categories, setRule_categories] = useState({})
	const [bool_open, setBool_open] = useState([false, false, false, false, false])
	const [bool_rule_open, setBool_rule_open] = useState([false, false, false, false, false, false])
	const [bool_pitch_open, setBool_pitch_open] = useState([false, false, false, false, false, false])
	const [arr_systems, setArr_systems] = useState([])
	const [selectedMenuIndex, setSelectedMenuIndex] = useState(0)

	useEffect(() => {
		//systems
		var array_menu = [];
		switch (props.section) {
			case "lists":
				array_menu.push("full", "short", "euro", "music", "math")
				break;
			case "practices":
				array_menu.push("full", "short")
				break;
			case "rules":
				array_menu.push('full', 'short', "music", "math");
				break;
			case "search":
				array_menu.push('full', 'short', 'euro');
				break;
			default:
				array_menu.push('nothing');
				break;
		}
		setArr_systems(array_menu)

		//categories
		let obj_categories = {};
		obj_categories.full = { ...context.state.full.getCategories() }
		obj_categories.short = { ...context.state.short.getCategories() };
		obj_categories.euro = context.state.euro.getCategories();
		obj_categories.music = context.state.music.getCategories();
		obj_categories.math = context.state.math.getCategories();
		if (props.section === "practices") {
			delete obj_categories.full.special;
			delete obj_categories.full.other;
			obj_categories.full[0] = { title: t('practice.char_all') };
			obj_categories.short[0] = { title: t("practice.short_all") };
		}
		setCategories(obj_categories)

		//rule categories
		let rule_categories = {};
		rule_categories.full = context.state.rules.getCategories("full")
		rule_categories.short = context.state.rules.getCategories("short")
		rule_categories.music = context.state.rules.getCategories("music")
		rule_categories.math = context.state.rules.getCategories("math")
		setRule_categories(rule_categories)

		//clear bools
		clearBools()
	}, [props.section])

	const expand = (index, system) => {
		props.onMenuClick(system, "")
		let copy = [...bool_open]
		copy[index] = !copy[index]
		setBool_open(copy)
	}
	const expand_rule = (index) => {
		var copy = [...bool_rule_open];
		for (let i in copy) {
			if (i === index) {
				copy[index] = !copy[index]
			} else {
				copy[i] = false
			}
		}
		setBool_rule_open(copy)
	}
	const expand_pitch = (index) => {
		var copy = [...bool_pitch_open];
		for (let i in copy) {
			if (i === index) {
				copy[index] = !copy[index]
			} else {
				copy[i] = false
			}
		}
		setBool_pitch_open(copy)
	}
	const clearBools = () => {
		var copy = [...bool_open];
		for (let i in copy) {
			copy[i] = false
		}
		var copy_rules = [...bool_rule_open];
		for (let j in copy_rules) {
			copy_rules[j] = false
		}

		var copy_pitch = [...bool_pitch_open];
		for (let k in copy_pitch) {
			copy_pitch[k] = false
		}
		setBool_open(copy)
		setBool_rule_open(copy_rules)
		setBool_pitch_open(copy_pitch)
	}
	const getCategories = (index, system) => {
		var systemEntries = {};
		var list = [];
		if (props.section === "lists" || props.section === "practices") {
			systemEntries = categories[system] || {}
			var category_entries = [];

			if (system !== "music") {
				for (let item in systemEntries) {
					category_entries.push(
						<ListItem button role="button"
							key={"cat_" + system + "_" + item}
							onClick={() => {
								props.onMenuClick(system, item)
							}}
						>
							<ListItemText className="menu_entry" primary={systemEntries[item].title} />
						</ListItem>
					)
				}
				list.push(
					<List key={"cat_" + props.section}>
						{category_entries}
					</List>
				)
			} else {
				//music menu
				let keys = Object.keys(systemEntries);
				var list_music_entries = [];
				for (let index in keys) {
					//render Pitches
					if (keys[index].startsWith("music")) {
						//aria Label
						var aria_label = systemEntries[keys[index]].title + " ";
						bool_pitch_open[index] ? aria_label = aria_label + "geöffnet" : aria_label = aria_label + "geschlossen";

						list_music_entries.push(
							<div>
								<ListItem aria-label={aria_label} button role="button"
									key={"cat_music" + keys[index] + "_" + index}

									onClick={() => {
										expand_pitch(index)
									}}>
									<ListItemText className="menu_entry" primary={systemEntries[keys[index]].title} />
									{bool_pitch_open[index] ?
										<ExpandLess /> :
										<ExpandMore />}
								</ListItem>
								<Collapse in={bool_pitch_open[index]} timeout="auto" unmountOnExit>
									{
										getPitchesForMusic(keys[index])
									}
								</Collapse>
							</div>
						)
						//render all other music entries
					} else {
						list_music_entries.push(
							<ListItem button role="button"
								key={"cat_music" + keys[index] + "_" + index}
								onClick={() => {
									props.onMenuClick(system, keys[index])
								}}>
								<ListItemText className="menu_entry" primary={systemEntries[keys[index]].title} />
							</ListItem>
						)
					}
					list.push(
						<List key="cat_music">
							{list_music_entries}
						</List>
					)
				}
			}
		} else if (props.section === "rules") {
			var list_rule_entries = [];
			systemEntries = rule_categories[system] || {}
			let keys = Object.keys(systemEntries);
			for (let index in keys) {
				//aria Label
				var aria_label = systemEntries[keys[index]].title + " ";
				bool_rule_open[index] ? aria_label = aria_label + "geöffnet" : aria_label = aria_label + "geschlossen";

				list_rule_entries.push(
					<div>
						<ListItem aria-label={aria_label} button role="button"
							onClick={() => {
								expand_rule(index)
							}}>
							<ListItemText className="menu_entry" primary={systemEntries[keys[index]].title} />
							{bool_rule_open[index] ?
								<ExpandLess /> :
								<ExpandMore />}
						</ListItem>
						<Collapse in={bool_rule_open[index]} timeout="auto" unmountOnExit>
							{
								getSubCategoriesForRules(system, index)
							}
						</Collapse>
					</div>
				)
			}
			list.push(
				<List>
					{list_rule_entries}
				</List>
			)
		}
		return list
	}
	const getMainMenuEntries = () => {
		var MenuEntries = [];

		for (let index in arr_systems) {
			var aria_label = t("common.systems." + arr_systems[index]);
			if (props.section !== 'search') {
				bool_open[index] ? aria_label = aria_label + " geöffnet" : aria_label = aria_label + " geschlossen";
				MenuEntries.push(
					<div key={'menu_div_' + index}>
						<ListItem
							className={index === selectedMenuIndex ? 'menu_active' : ''}
							key={Math.random()}
							aria-label={aria_label}
							button role="button"
							onClick={() => {
								setSelectedMenuIndex(index)
								expand(index, arr_systems[index])
							}}
						>
							<ListItemText key={Math.random()} aria-label={t("common.systems." + MenuEntries[index])}
								primary={t("common.systems." + arr_systems[index])}
							/>
							{bool_open[index] ?
								<ExpandLess /> :
								<ExpandMore />}
						</ListItem>
						<Collapse in={bool_open[index]} timeout="auto" unmountOnExit component="li">
							{getCategories(index, arr_systems[index])}
						</Collapse>

					</div>
				)
			} else {
				aria_label = t("common.systems." + arr_systems[index]) + "Suche";
				if (selectedMenuIndex === index) {
					aria_label += " Aktiviert"
				}
				MenuEntries.push(
					<div key={'menu_div_' + index}>
						<ListItem
							className={index === selectedMenuIndex ? 'menu_active' : ''}
							key={Math.random()}
							aria-label={aria_label}
							button role="button"
							onClick={() => {
								setSelectedMenuIndex(index)
								props.onMenuClick(arr_systems[index], "")

							}}
						>
							<ListItemText key={Math.random()} aria-label={t("common.systems." + MenuEntries[index])}
								primary={t("common.systems." + arr_systems[index])}
							/>
						</ListItem>
					</div>
				)
			}
		}

		return MenuEntries
	}
	const getPitchesForMusic = (item) => {
		let alteration = item.startsWith("music_alterated");
		let sharp = item === "music_alterated_sharp_notes"
		var list = [];
		var entries = {};
		if (alteration) {
			entries = context.state.music.getNotes(true, sharp);
		} else {
			entries = context.state.music.getNotes(false);
		}
		var music_entries = [];

		for (let index in entries) {
			music_entries.push(
				<ListItem button role="button"
					key={"pitch_" + item + "_" + index}
					onClick={() =>
						props.onMenuClick("music", item, index, sharp)
					}>
					<ListItemText className="rule_entry" primary={entries[index].title} />
				</ListItem>
			)
		}
		list.push(
			<List key={"pitch_" + item}>
				{music_entries}
			</List>
		)
		return list;
	}
	const getSubCategoriesForRules = (system, index) => {
		var list = [];
		let systemEntries = rule_categories[system] || {}
		let keys = Object.keys(systemEntries);
		let content = systemEntries[keys[index]].content
		for (let i in content) {
			list.push(
				<ListItem button role="button" onClick={() =>
					props.onMenuClick(system, i, "", "", keys[index])
				}>
					<ListItemText className="rule_entry" primary={content[i].title} />
				</ListItem>
			)
		}
		return list;
	}
	return (
		<div className='side_menu_container'>
			<List key="main_list" className='side_menu'>
				{
					getMainMenuEntries()
				}
			</List>
		</div>
	)
}
export default MenuView;